import React from 'react'
import DsButton from 'components/ds/Button'
import strings from 'strings'
import CreditCost from 'components/shared/CreditCost'
import './GetAllDataAlert.scss'

const summaryStrings = strings.APPLICANT.SUMMARY

const GetAllDataAlert = (props) => {

    const { display, handleGetAllData, applicantId, loading, creditCosts, creditUsageEnabled, count = 0 } = props

    const handleGetAllDataButton = () => {
        handleGetAllData(applicantId)
    }

    // Get credit cost for GET_ALL_DATA request type
    const getCreditCostForGetAllData = () => {
        if (!creditCosts || !Array.isArray(creditCosts)) return 0 // fallback to default value

        const costData = creditCosts.find(cost => cost.requestType === 'GET_ALL_DATA')
        return costData ? costData.creditCost : 0 // fallback to default value
    }

    const copy = count > 1
        ? summaryStrings.REPORTS_NOT_RUN.replace('{count}', count)
        : count === 1
            ? summaryStrings.ONE_REPORT_NOT_RUN
            : summaryStrings.GET_ALL_DATA_TEXT

    const action = count > 1
        ? summaryStrings.RUN_REPORTS.replace('{count}', count)
        : count === 1
            ? summaryStrings.RUN_ONE_REPORT
            : summaryStrings.GET_ALL_DATA

    return (
        <>
            {display &&
                <div className='bulkRunBar'>
                    <p className='bulkRunBar__copy'>{copy}</p>
                    <DsButton
                        variant='primary'
                        size='small'
                        onClick={() => handleGetAllDataButton()}
                        loading={loading}
                        id='get-all-data'
                    >
                        {action}
                        {creditUsageEnabled &&
                            <span className='bulkRunBar__credits'>
                                <CreditCost cost={getCreditCostForGetAllData()} />
                            </span>
                        }
                    </DsButton>
                </div>
            }
        </>
    )
}

export default GetAllDataAlert
